import { Injectable } from '@angular/core';
import { tap, map } from 'rxjs/operators';
import { retry, catchError } from 'rxjs/operators';

import { AuthStore, ReturnAuthState, AuthState } from './auth.store';
import { AuthHttpService } from './auth-http-service';
import { AuthQuery } from '@app/auth/auth.query';
import { resetStores } from '@datorama/akita';

@Injectable({
  providedIn: 'root',
})
export class AuthDataService {
  arMonate = [];

  constructor(private authStore: AuthStore, private authHttpService: AuthHttpService, private authQuery: AuthQuery) {}

  private mapAuthFromResponse(data: any): AuthState {
    return {
      appid: data.appid,
      access_token: data.access_token,
      token_type: data.token_type,
      expires_in: data.expires_in,
      refresh_token: data.refresh_token,

      name: data.name,
      company: data.company,
      email: data.email,
      role: data.role,
      role_name: data.role_name,
      su: data.su != null ? Number(data.su) : 0,
      demo_mode: data.demo_mode != null ? Number(data.demo_mode) : 0,
      permissions: data.permissions || {},

      profile_image: data.profile_image,

      firststart: data.firststart,
      firststart_done: data.firststart_done,
      version: data.version,
      appdata: data.appdata,
      userid: data.userid,
      fid: data.fid,

      isactivated: data.isactivated,
      isapproved: data.isapproved,
      status: data.status,

      country: data.country,

      phone_id: data.phone_id,
      gemeinde_key: data.gemeinde_key,
      accesspoint: data.accesspoint,
      request_ip: data.request_ip,

      dienstnr: data.dienstnr,
      dienstname: data.dienstname,
      dienstnr_stvo: data.dienstnr_stvo,
      sachbereich: data.sachbereich,
    };
  }

  login(creds: any) {
    return this.authHttpService.login(creds).pipe(
      tap((data: ReturnAuthState) => {
        this.authStore.save(this.mapAuthFromResponse(data));
      })
    );
  }

  register(data: any) {
    return this.authHttpService.register(data).pipe(
      tap((data) => {
        this.authStore.save(this.mapAuthFromResponse(data));
      })
    );
  }

  firststart(firststartData: any) {
    return this.authHttpService.firststart(firststartData).pipe(
      tap((data) => {
        this.authStore.save(this.mapAuthFromResponse(data));
      })
    );
  }

  updateVersion(version: any) {
    this.authStore.update({ version: version });
  }

  updateDemoMode(demoMode: number) {
    const value = Number(demoMode) === 1 ? 1 : 0;
    this.authStore.update({ demo_mode: value });
    const current = this.authStore.getValue();
    this.authStore.save({ ...current, demo_mode: value });
  }

  updateFirststart(firststart: any) {
    this.authStore.update({ firststart: firststart });
  }

  changepwd(data: any) {
    return this.authHttpService.changePassword(data).pipe(
      tap((data) => {
        // we have to do some mapping
      })
    );
  }

  forgotpwd(data: any) {
    return this.authHttpService.forgotPassword(data).pipe(
      tap((data) => {
        // we have to do some mapping
      })
    );
  }

  logout() {
    return this.authHttpService.logout().pipe(
      tap((auth) => {
        //console.log('remove all stores');
        this.authStore.remove();
        resetStores({
          //exclude: ['storeNameToKeep']
        });

        // Clear localStorage or sessionStorage where Akita's persistState might have stored data
        // If you are using specific keys for persistState, you might want to clear those specifically
        // For example: localStorage.removeItem('persistedStoreKey');
        localStorage.clear(); // Use with caution; this clears everything in localStorage
      })
    );
  }
}
